const emailStatisticsMenuPaths = (id) => [
  {
    name: 'Statistics',
    pathName: `/reporting/email-statistics/${id}`,
    exact: true,
  },
  {
    name: 'Activity',
    pathName: `/reporting/email-statistics/${id}/activity`,
    exact: false,
  },
  {
    name: 'Suppressions',
    pathName: `/reporting/email-statistics/${id}/suppressions`,
    exact: true,
  },
  {
    name: 'Statistics by Filter',
    pathName: `/reporting/email-statistics/${id}/statistics-by-filter`,
    exact: true,
  },
];

export default emailStatisticsMenuPaths;
